import { Component, Inject, OnInit, ViewEncapsulation } from '@angular/core';
import { Router } from '@angular/router';
import { ApiRequestService, ToastmessageService, TranslationPipe, TranslationService } from '@prekog/common-ui';
import { BlogSlideshowComponent } from '../blogslideshow/blog-slideshow.component';
import { DiscountedProductOfferingComponent } from '../discountedproductoffering/discounted-product-offering.component';
import { DiscountedPackageOfferingComponent } from '../discountedpackageoffering/discounted-package-offering.component';
import { HomeInfoComponent } from '../homeinfo/home-info.component';
import { OnSaleProductsComponent } from "../onsaleproducts/onsaleproducts.component";
import { NoveltyProductsComponent } from '../noveltyproducts/novelty-products.component';
import { Material } from '../shared/material.model';
import { PublicationService } from '../shared/publication.service';
import { HomeConfig } from '../shared/home-config.model';
import { HomeConfigResponse } from './get-home-configs.response';

@Component({
    encapsulation: ViewEncapsulation.None,
    selector: 'pf-home',
    templateUrl: './home.component.html',
    styleUrls: ['./home.component.scss'],
    imports: [
        HomeInfoComponent,
        NoveltyProductsComponent,
        DiscountedProductOfferingComponent,
        DiscountedPackageOfferingComponent,
        BlogSlideshowComponent,
        TranslationPipe,
        OnSaleProductsComponent
    ]
})
export class HomeComponent implements OnInit {
    bannerThumbUrl = '../../assets/configurations/blog-thumb.json';

    configuratorBaseUrl = '';
    getHomeConfigsUrl = '/websiteconfigurator/get-homeconfigs';

    homeConfigList: HomeConfig[] = [];

    constructor(
        private _publicationService: PublicationService,
        private _router: Router,
        private _toastMessageService: ToastmessageService,
        private _apiRequestService: ApiRequestService,
        @Inject('CONFIGURATOR_BASE_URL') private _configuratorBaseUrl: string,
        private _translateService: TranslationService
    ) {
        this.configuratorBaseUrl = _configuratorBaseUrl;
    }

    ngOnInit(): void {
        this._apiRequestService
            .sendRequest<{}, HomeConfigResponse>(this.configuratorBaseUrl, {}, true, this.getHomeConfigsUrl)
            .subscribe((response) => {
                this.homeConfigList = response.homeConfigList as HomeConfig[];
            });
    }

    addToCart(material: Material) {
        this._publicationService.addToCart(material);
    }
}
